import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('accordion');

export { TAG_NAME };
